import { View } from 'react-native';
import styled from 'styled-components/native';

type Props = {
  left?: React.ReactNode;
  right?: React.ReactNode;
};

export const ScreenBottomBar = (props: Props) => {
  const { left, right } = props;

  return (
    <Container>
      <View>{left}</View>
      <View>{right}</View>
    </Container>
  );
};

const Container = styled.View`
  width: 100%;
  background-color: #051633;
  padding: 16px 32px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
